/* eslint-disable camelcase */
// 接口文档：http://confluence.mobvista.com/pages/viewpage.action?pageId=35005488#id-%E3%80%90%E5%90%8E%E7%AB%AF%E3%80%91DCO%E9%A1%B9%E7%9B%AE%E4%B8%80%E6%9C%9F-j%E3%80%81%E5%89%8D%E5%90%8E%E7%AB%AF%E5%AF%B9%E6%8E%A5
import _ from 'lodash'
import sortJson from 'sort-json'
import { Message } from 'element-ui'
import { saveDmakerTemplate } from '@/api/creative/template'
import { saveDmakerCustom } from '@/api/creative/custom'
import { cookResourceConfig } from '../common/resource.js'
import { saveGmakerProject } from '@pt/api/gmaker/project.js'
import { saveGmakerTemplate } from '@/api/gmaker/template.js'
import { cookResources } from '../common/resource.js'
import cookPackedGroupsConfig from '../common/cook-packed-groups-config.js'
import getCurrentGroupJsonConfig from '../common/get-current-group-json-config.js'
import {
  gameConfigCategoryResourceType,
  isGlobalCategory,
} from '@/store/creative/common/category'
import checkJsonConfigForbiddenFont from '@/utils/checkJsonConfigForbiddenFont'
import { dealPtVersionI18n } from '@/utils/checkJsonConfigForbiddenFont'
import {
  gameConfigToi18nStore,
  getEventAndTween,
} from '@com/utils/i18n-store-conversion'
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category'
import { isCocosModelCategory } from '@/views/creative/utils'
import {
  getAnimationList,
  syncModelAnimationListToTemplateCategory,
} from '@/views/creative/utils/model-animation-utils'

/**
 * 处理分类配置，保存模板配置时使用
 * @param {[]} data
 * @returns {[]}
 */
export function cookCategoryConfig(data) {
  const traverse = (category) => {
    return category
      .map((item) => {
        const newCat = {
          ..._.pick(item, [
            'dco_part_id',
            'file_ext',
            'file_type',
            'id',
            'is_define',
            'lg_type',
            'name',
            'name_en',
            'pid',
            'prefix',
            'res_cat1_id',
            'res_cat2_id',
            'res_type',
            'resource_type',
            'sub_resource_type',
          ]),
          sub_category: item.sub_category ? traverse(item.sub_category) : null,
        }
        // 坑位属性
        if (_.get(item, 'properties')) {
          newCat.properties = JSON.stringify(item.properties)
        }
        return newCat
      })
      .filter((item) => {
        // 一些特殊的玩法分类不需要保存，每次重新生成即可，只有配置在 gameConfig.json 里的 gameConfig 属性下的配置才需要保存
        if (item.resource_type === gameConfigCategoryResourceType) {
          return !isGlobalCategory(item.id)
        }
        return true
      })
  }

  return traverse(_.cloneDeep(data))
}

/**
 * cookApiParams
 * @param {{id: number, page: string, skinId: number}} param0
 */
function cookApiParams({ id, page, skinId, templateType }) {
  const saveProject = () => {
    return {
      params: {
        project_id: id,
      },
      request: saveGmakerProject,
    }
  }
  const commonTemplateCustomApiUtils = {
    'common-template-custom': saveProject,
  }

  const templateCustomApiUtils = {
    custom: () => {
      return {
        params: {
          custom_id: id,
        },
        request: saveDmakerCustom,
      }
    },
  }

  const templateApiUtils = {
    template: () => {
      if (templateType === 'gm') {
        return {
          params: {
            template_id: id,
          },
          request: saveGmakerTemplate,
        }
      }
      return {
        params: {
          template_id: id,
        },
        request: saveDmakerTemplate,
      }
    },
    'common-template': () => {
      return {
        params: {
          template_id: id,
          skin_id: skinId,
        },
        request: saveGmakerTemplate,
      }
    },
  }

  const apiUtils = {
    ...templateApiUtils,
    ...commonTemplateCustomApiUtils,
    ...templateCustomApiUtils,
  }

  return apiUtils[page]() || null
}

function eachLanguages(languages) {
  _.each(languages, (language) => {
    // language
    _.each(language, (text, key) => {
      // style
      const style = _.get(text, 'style')
      if (_.isEmpty(style)) return
      // 清理 fontUrl/font 属性
      _.each(style, (styleValue, key) => {
        // fontUrl 不需要，只提供给实时预览使用的属性
        if (key === 'fontUrl') {
          delete style.fontUrl
        }
        // font 为空时删掉该属性
        // （为空实际上还是使用默认字体，所以不需要保存。保存的话会导致扩展包整理 md5 变化，导致 pt 下载计数发生变化）
        if (key === 'font' && _.isEmpty(styleValue)) {
          delete style.font
        }
      })
      language[key].style = style
    })
  })
}

function eachGroupsConfig(groupsConfig) {
  _.each(groupsConfig, (group) => {
    const languages = _.get(group, 'i18n.data.languages')
    const packLanguages = _.get(group, 'i18n.packData.languages')
    eachLanguages(languages)
    eachLanguages(packLanguages)
  })
}

// eslint-disable-next-line prettier/prettier
export default async function (
  { commit, dispatch, state, rootState },
  config = {},
) {
  if (state.isReadonly) {
    Message({
      message: 'Read Only',
      type: 'error',
      duration: 5 * 1000,
    })
    return
  }

  if (state.templateState === 'saving') return

  const { autoSave = false, omitKeys = [] } = config
  console.log(omitKeys, 'omitKeys')

  const {
    category,
    json_config,
    resource,
    allow_add_language,
    mw_config,
    supported_mw_configs,
    play_config,
    actions,
  } = state.templateConfig

  const apiParams = cookApiParams({
    page: state.page,
    id: state.id,
    skinId: state.skinId,
    templateType: state.templateType,
  })

  if (!apiParams) throw new Error('Fail to save template')

  try {
    commit('updateTemplateState', 'saving')

    const params = apiParams.params
    const data = {}

    // 直接传空字符串后端会忽略
    data.play_config = JSON.stringify(play_config || {})

    // 增加模板映射actions字段保存
    if (actions) {
      data.actions = JSON.stringify(actions || {})
    }

    // 如果存在 editorConfig，需要回传
    if (
      play_config &&
      play_config.editorConfig &&
      play_config.editorConfig.i18nStore &&
      play_config.editorConfig.i18nStore.length
    ) {
      const newGameConfigStore = gameConfigToi18nStore(
        play_config.gameConfig,
        json_config,
      )
      const newEditorConfigStore = getEventAndTween(
        play_config.editorConfig.i18nStore,
      )
      const extEditorConfig = {}
      extEditorConfig.i18nStore =
        newGameConfigStore.concat(newEditorConfigStore)
      data.ext_editor_config = JSON.stringify(extEditorConfig)
    }

    // category
    if (category) {
      data.category_config = JSON.stringify(cookCategoryConfig(category))
    }

    // language
    data.language = state.currentLanguage
    if (_.isPlainObject(_.get(json_config, 'i18n.languages'))) {
      data.language = Object.keys(_.get(json_config, 'i18n.languages')).join(
        ',',
      )
    }

    // 收藏
    if (state.starsConfig) {
      data.stars_config = JSON.stringify(state.starsConfig)
    }

    // resource
    if (resource) {
      data.resource_config = JSON.stringify(
        cookResourceConfig(resource, {
          isMultiCustom: state.isMultiCustom,
        }),
      )
    }

    if (!_.isEmpty(mw_config) && !_.isEmpty(supported_mw_configs)) {
      data.mw_config = JSON.stringify(mw_config)
    }

    // 模板页面
    if (state.isTemplate) {
      // 是否对外开放添加语言功能
      if (allow_add_language) {
        data.allow_add_language = allow_add_language
      }
    }

    const clearDirtyData = ({ jsonConfig, gameConfigResource }) => {
      jsonConfig = _.cloneDeep(jsonConfig)
      gameConfigResource = _.cloneDeep(gameConfigResource)
      const rec = (conf) => {
        if (_.isPlainObject(conf) && _.has(conf, 'mw_mapping_path')) {
          delete conf.mw_mapping_path
        }
        // 递归优先处理所有子项
        if (_.isArray(conf)) {
          conf.forEach((item) => rec(item))
        } else if (_.isPlainObject(conf)) {
          Object.values(conf).forEach((item) => rec(item))
        }
        // 递归后再同步 items 到 value，并删除 items 字段
        if (
          _.isPlainObject(conf) &&
          (conf.type === 'arrayObject' || conf.type === 'object') &&
          conf.items &&
          conf.value
        ) {
          conf.value = _.cloneDeep(conf.items)
          delete conf.items
        }
      }
      if (!_.isEmpty(_.get(jsonConfig, 'gameConfig'))) {
        const gameConfig = _.get(jsonConfig, 'gameConfig')
        rec(gameConfig)
      }
      if (!_.isEmpty(gameConfigResource)) {
        rec(gameConfigResource)
      }
      return {
        jsonConfig,
        gameConfigResource,
      }
    }
    const cleanData = clearDirtyData({
      jsonConfig: state.templateConfig.json_config,
      gameConfigResource: state.gameConfigResource,
    })
    let jsonConfig = cleanData.jsonConfig
    const gameConfigResource = cleanData.gameConfigResource
    const { i18nResource, previewLanguageList, groupsConfig } = state
    const packedGroupsConfig = cookPackedGroupsConfig({
      groupsConfig,
      previewLanguageList,
      i18nResource,
      jsonConfig,
      gameConfigResource,
      category,
    })
    eachGroupsConfig(packedGroupsConfig)

    const cookedPreviewGroupConfig = packedGroupsConfig.find(
      (item) => item.name === state.previewGroup,
    )

    jsonConfig = getCurrentGroupJsonConfig({
      previewGroup: state.previewGroup,
      groupsConfig: packedGroupsConfig,
      gameConfigResource: gameConfigResource,
    })
    // 如果含有 modelModifyConfig 的数据，需要保存
    if (!_.isEmpty(rootState.creative.modelEditor.modelModifyConfig)) {
      jsonConfig.modelModifyConfig =
        rootState.creative.modelEditor.modelModifyConfig
    }
    // 如果含有镜头参数的数据，需要保存
    if (
      !_.isEmpty(
        rootState.creative.modelEditor.cameraAdaptConfig.adapt.adaptDatas,
      ) ||
      !_.isEmpty(rootState.creative.modelEditor.cameraAdaptConfig.orbitParams)
    ) {
      jsonConfig.cameraConfig = rootState.creative.modelEditor.cameraAdaptConfig
    }
    // 排序是为了保证只有顺序变化时，保证后端计算md5正确
    data.json_config = JSON.stringify(sortJson(jsonConfig))

    // pack_json_config 用作打包的 json 配置
    const packJsonConfig = {
      ..._.cloneDeep(jsonConfig),
      i18n: _.get(cookedPreviewGroupConfig, 'i18n.packData'),
    }
    // 保存时更新加载自定义字体
    if (state.isCommonTemplateCustom) {
      await dispatch('assets/resource/getAssetFontList', null, { root: true })
    }

    // 通用模版才有自定义字体
    const assetFontList = state.isCommonTemplateCustom
      ? rootState.assets.resource.assetFontList
      : []
    const { status, forbiddenList } = await checkJsonConfigForbiddenFont(
      dealPtVersionI18n(i18nResource),
      rootState.config.fontList,
      assetFontList,
    )
    // 一键替换下架字体
    if (status) {
      this.commit('creative/forbiddenFont/updateForbiddenFontDialog', {
        visible: true,
        forbiddenFontList: forbiddenList,
        fontOptions: rootState.config.fontList.concat(assetFontList),
        assetFontConfig: { list: state.isCommonTemplateCustom },
      })
    }
    if (status) {
      throw new Error('非法字体无法继续操作')
    }

    data.pack_json_config = JSON.stringify(sortJson(packJsonConfig))

    await apiParams.request(params, _.omit(data, omitKeys), autoSave)
    commit('updateTemplateState', 'saved-successfully')
    dispatch('previewTemplate')
    dispatch('getTemplateInfo', {
      afterRequest: async (res) => {
        // 由于静态资源不是一揽子的更新方式，所以保存完之后需要重新获取资源，用于保存新增删除逻辑正确
        // 如新增资源保存，然后再删除再保存，如果不重新获取资源，那么删除的时候就没有资源 id，就无法完成删除操作
        const resourceList = _.get(res, 'data.data.resource')
        if (
          resourceList &&
          state.templateConfig &&
          state.templateConfig.resource
        ) {
          state.templateConfig.resource = cookResources(resourceList)
        }
        try {
          // 如果是重置坑位，并且重置的坑位是模型坑位，那么需要重新刷新坑位的 properties 数据
          if (
            omitKeys.includes('category_config') &&
            data.resource_config &&
            JSON.parse(data.resource_config).length
          ) {
            const categoryInfo = _.get(res, 'data.data.category_config', {})
            JSON.parse(data.resource_config).forEach((item) => {
              if (item.action === 'reset') {
                const categoryId = item.category_id
                const targetCategory = useIdToFindCategory({
                  category: state.templateConfig.category,
                  categoryId,
                })
                const targetCategoryInfo = useIdToFindCategory({
                  category: categoryInfo,
                  categoryId,
                })
                if (targetCategoryInfo && targetCategoryInfo.properties) {
                  targetCategoryInfo.properties = JSON.parse(
                    targetCategoryInfo.properties,
                  )
                }
                // 如果是模型数据，需要同步模型分类的动作数据到模板分类中，
                if (
                  targetCategory &&
                  isCocosModelCategory(targetCategory) &&
                  targetCategory.properties
                ) {
                  const modelAnimationList =
                    getAnimationList(targetCategoryInfo)
                  // default 的动作，如果有两个绑定的模型，则不能被删除，因为另外一个模型也会有这个动作的配置参数，删除会影响到其他
                  if (
                    targetCategory.properties.model_animation_list &&
                    targetCategory.properties.model_animation_list.length &&
                    targetCategory.properties.model_animation_list.some((i) => {
                      return i.is_default && i.model_category_ids.length > 1
                    })
                  ) {
                    targetCategory.properties.model_animation_list
                      .filter(
                        (i) => i.is_default && i.model_category_ids.length > 1,
                      )
                      .forEach((i) => {
                        const index = modelAnimationList.findIndex(
                          (j) => j.file_path === i.file_path,
                        )
                        if (index === -1) {
                          modelAnimationList.push(i)
                        } else {
                          modelAnimationList[index] = i
                        }
                      })
                  }
                  syncModelAnimationListToTemplateCategory({
                    modelAnimationList,
                    modelCategory: targetCategory,
                    templateCategory: state.templateConfig.category,
                  })
                  if (targetCategoryInfo.properties) {
                    console.log(
                      '当前重置的坑位有 properties 数据,直接赋值 model_material_list',
                      targetCategory.name,
                    )
                    const cloudInfo = targetCategoryInfo.properties
                    if (cloudInfo.model_material_list) {
                      targetCategory.properties.model_material_list =
                        cloudInfo.model_material_list
                    } else {
                      targetCategory.properties.model_material_list = []
                    }
                  } else {
                    console.log(
                      '当前重置的坑位有没有 properties 数据,直接删除 model_material_list',
                      targetCategory.name,
                    )
                    targetCategory.properties.model_material_list = []
                  }
                }
              }
            })
            await dispatch('rebuildCategory')
          }
        } catch (e) {
          console.log('重置坑位失败', e)
        }
      },
    })
  } catch (e) {
    console.error(e)
    commit('updateTemplateState', 'editing')
    throw new Error('Save failed.')
  }
}
